import { getConfig } from './getConfig.ts';

export type Marker = {
  lat: number;
  lon: number;
  label?: string;
  name?: 'pin-s' | 'pin-l';
  color: string;
};

export enum PinColors {
  SUBJECT = 'D55E00', // orange
  PENDING = 'CC79A7', // pink
  SOLD = '0072B2', // blue
  ACTIVE = '019E73', // green
  OFF_MARKET = '657888', // grey
  RENTED = 'E79F00', // red-orange
}

export const getMapboxStaticURL = (
  lat?: number | null,
  lon?: number | null,
  size: string = '400x400',
  style: 'satellite' | 'road' = 'satellite',
  markers?: Marker[],
  boundedBox?: string,
) => {
  const [width, height] = size.split('x').map(Number);
  const token = getConfig('MAPBOX_API_KEY') as string;

  // Map style mapping
  const styleMap: Record<typeof style, string> = {
    satellite: 'mapbox/satellite-v9',
    road: 'mapbox/streets-v11',
  };

  // Add custom markers if provided
  let markerParams;
  if (markers && markers.length > 0) {
    markerParams = markers
      .map((marker) => {
        const { name, label, color, lon: markerLon, lat: markerLat } = marker;

        return `${name}-${label}+${color}(${markerLon},${markerLat})`;
      })
      .join(',');
  }

  const pathParam = boundedBox
    ? `path-1+${PinColors.RENTED}-1+${PinColors.RENTED}-0.1(${encodeURIComponent(boundedBox)})`
    : '';

  const overlay = markerParams && pathParam ? `${markerParams},${pathParam}/` : '';
  const center = lat != null && lon != null ? `${lon},${lat},18` : 'auto';

  // Padding can only be used with 'auto' center or a provided bounding box.
  // See: https://docs.mapbox.com/api/maps/static-images/
  const paddingParam = center === 'auto' || boundedBox ? '&padding=50,25,50,25' : '';
  return `https://api.mapbox.com/styles/v1/${styleMap[style]}/static/${overlay}${center}/${width}x${height}@2x?logo=false${paddingParam}&access_token=${token}`;
};
